/**
 * @description
 * the computed data of model data table
 */
export default {
    /**
     * @description
     * show the filter option and filter form
     */
    canFilter() {
        return !this.noFilter && this.toolbar.filtering
    },

    /**
     * @description
     * show the pagination
     */
    canPagination() {
        return !this.noPagination
    },

    /**
     * @description
     * show the toolbar
     */
    canToolbar() {
        return !this.noTools
    },

    /**
     * @description
     * the current filter param to request
     */
    currentFilter() {
        return {
            [this.paramSearch]: this.noSearch ? undefined : this.currentSearch,
            ...this.mapperFilter(this.filter || {}),
            ...this.attachFilter,
            ...this.mapFilter(this.paramFilter),
        }
    },

    /**
     * current pagination limit
     */
    currentLimit() {
        return parseInt(this.pagination.limit, 10) || 10
    },

    /**
     * current pagination page
     */
    currentPage() {
        return parseInt(this.pagination.current, 10) || 1
    },

    /**
     * current request params
     */
    currentParams() {
        return {
            ...this.attachParams,
            filter: this.currentFilter,
        }
    },

    /**
     * @description
     * current request search
     */
    currentSearch() {
        return String(this.toolbar.search)
    },

    /**
     * @description
     * current request sort
     */
    currentSort() {

        //
        const sortable = this.currentSortHeader.sortable
        const value = this.currentSortValue

        //
        return sortable && value ?
            `${this.order.desc ? '-' : ''}${this.currentSortValue}`
            : 
            undefined
    },

    /**
     * @description
     * current header order
     */
    currentSortHeader() {
        return this.headers[this.order.index] || {}
    },

    /**
     * @description
     * current request sort value
     */
    currentSortValue() {
        return this.currentSortHeader.sortable ? 
            typeof this.currentSortHeader.sortable === 'string' ? 
                this.currentSortHeader.sortable
                : 
                this.currentSortHeader.value === 'string' ?
                    this.currentSortHeader.value
                    :
                    undefined
            : 
            undefined
    },

    /**
     * @description
     * the current filter form props
     */
    filterProps() {
        return {
            items: this.filters,
            initialValues: this.initialFilterValues,
        }
    },

    /**
     * @description
     * the header actions definition
     */
    headersActions() {
        return [
            {
                align: 'center',
                text: 'acciones',
                sortable: false,
                width: '15%',
            },
        ]
    },

    /**
     * @description
     * show the checkable table items
     */
    isCheckable() {
        return this.checkable && !this.readonly && this.tableItems.length > 0
    },

    /**
     * @description
     * get the table headers to render
     */
    tableHeaders() {
        return this.noActions
            ? this.headers
            : this.headers.concat(this.headersActions)
    },

    /**
     * @description
     * get the table items to render
     */
    tableItems() {
        return Array.isArray(this.data || [])
            ? this.data
            : Object.values(this.data || {})
    },

    /**
     * @description
     * get the table props to bind
     */
    tableProps() {
        return {
            expand: this.expand,
            headers: this.activeHeaders || this.tableHeaders,
            hideActions: Boolean(!this.showNativePagination),
            items: this.tableItems,
            //itemKey: 'id',
            noDataText: String(this.busy ? this.loadingText : this.noDataText),
            rowsPerPageItems: this.tableRowsPerPageItems,
            rowsPerPageText: String(this.rowsPerPageText),
        }
    },

    /**
     * @description
     * get the last rows per page item to bind native pagination
     */
    rowsPerPageLastItem() {
        return {
            text: 'Todo',
            value: -1,
        }
    },

    /**
     * @description
     * get the rows per page items to bind native pagination
     */
    tableRowsPerPageItems() {
        return [...this.rowsPerPageItems, this.rowsPerPageLastItem]
    },

    /**
     * @description
     * get the pagination props to bind
     */
    paginationProps() {
        return {
            color: this.color,
            loading: this.busy && this.loadingColor,
        }
    },

    /**
     * @description
     * get the toolbar props to bind
     */
    toolbarProps() {
        return {

            //
            alwaysExport: Boolean(this.alwaysExport),
            color: String(this.toolbarColor),
            dark: Boolean(this.toolbarDark),
            dense: Boolean(this.toolbarDense),
            disabled: Boolean(this.busy || this.readonly),
            noExport: Boolean(this.noExport),
            noFilter: Boolean(this.noFilter),
            noHelper: Boolean(this.noHelper),
            noRefresh: Boolean(this.noRefresh),
            noSearch: Boolean(this.noSearch),
            searchPlaceholder: String(this.searchPlaceholder),

            /**
             * @description
             * sub components props
             */
            adderProps: this.adderProps,
            pickerProps: this.pickerProps,

            /**
             * @description
             * show flags
             */
            showAdder: this.showAdder && !this.readonly,
            showPicker: Boolean(this.showPicker && !this.readonly),
            showRemove: Boolean(this.showRemove && !this.readonly),
            showColumnSelect: this.selectableColumns,

            /**
             * @description
             * toolbar title
             */
            title: String(this.toolbarTitle || ''),
            filterLength: Object.keys(this.filter).length,
        }
    },
}
